import {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {loadDatabases} from '../../../shared/store/actions/databaseActions';
import {loadIntegrations} from '../../../shared/store/actions/integrationActions';
import {loadReport, unsetReport} from '../../../shared/store/actions/reportFormActions';
import {unsetBlocks} from '../../../shared/store/actions/blockActions';
import {unsetBlockExecutions} from '../../../shared/store/actions/blockResultActions';
import {unsetReportExecutions} from '../../../shared/store/actions/reportResultActions';
import {INTEGRATION_LOADING_SOURCE} from '../../../shared/models';

const LOAD_PARAMS = {
  page: 0,
  page_size: -1,
  reload: true,
}

export function useInitReport(reportId: string) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadDatabases(LOAD_PARAMS));
    dispatch(loadIntegrations({
      ...LOAD_PARAMS,
      source: INTEGRATION_LOADING_SOURCE.REPORT,
    }));

    if (!reportId) {
      return;
    }
    dispatch(loadReport(reportId));

    return () => {
      dispatch(unsetReport());
      dispatch(unsetBlocks());
      dispatch(unsetBlockExecutions());
      dispatch(unsetReportExecutions());
    }
  }, []);
}
